<template lang="pug">
  #signUpIndex.w-100.h-100
    #appHeader.d-flex.align-items-center.justify-content-center
      i.fas.fa-chevron-left.fa-lg.icon-back(
        @click="$router.push({ name: 'm-card', params: { utm_source: utm_source }})"
        style='left: 20px;'
        :style="{ color: CARD_NO === 'DP' ? '#FFFFFF' : '#000000' }"
        v-if="CARD_NO"
      )
      b-img.h-100.w-100(
        fluid,
        :src="logoImg",
        alt="logo",
        v-if="CARD_NO"
        @click="backHandler('logo')"
      )
    .content-padding-top
    .container.p-3.w-100
      div.text.text-red 顯示一年內消費紀錄，金額為消費完成付款後24小時內可查詢
      .title.mt-3.whiteArea.border-rounded.p-3.box-shadow
        .row
          .col-6
            div 一年內消費總額 (元)
            div.font-weight-bold {{ record.SL_TOTAL ? numberFormat(record.SL_TOTAL) : 0 }}
          .col-6
            div 累積點數 (點)
            div.font-weight-bold {{ numberFormat(record.Y_POINT) }}
      .record.whiteArea.box-shadow.border-left-grown.mt-3.m-0.border-top-right-rounded.border-bottom-right-rounded(v-for="(datum, index) in record.item")
        .p-3
          div
            span.text-brown {{ datum.SL_DATE }}
            span.ml-3 {{ datum.S_NAME }}
          .row.mt-2.position-relative
            .col-6
              div.white-space-nowrap 消費總金額 (元)
              div {{ numberFormat(datum.SL_AMT) }}
            .col-6
              div 點數異動 (點)
              div + {{ numberFormat(datum.SL_POINT) }}
            img.arrow-down-icon(:src='IconArrowDown' @click='toggleShowDetail(index)' v-if='!datum.showDetail')
            img.arrow-top-icon(:src='IconArrowDown' @click='toggleShowDetail(index)' v-else)
        .detail.grayArea.border-bottom-right-rounded(v-show='datum.showDetail')
          .p-3
            .row.pt-2.no-gutters
              .col-6.text-gray 消費品項
              .col-2.white-space-nowrap.text-right.text-gray 數量
              .col-4.white-space-nowrap.text-right.text-gray 金額 NT$
            .row.mt-2.pb-2.no-gutters(v-for='detail in datum.Detail')
              .col-6 {{ detail.P_NAME }}
              .col-2.white-space-nowrap.text-right {{ numberFormat(detail.Qty) }}
              .col-4.white-space-nowrap.text-right {{ numberFormat(detail.Price * 100 / 100) }}

</template>

<script>
  import IconArrowDownUrl from '@/assets/images/card/arrow-down.png';
  import defaultLogoUrl from '@/assets/images/logo/logo.png';

  export default {
    name: 'SignUpIndex',
    components: {
    },
    props: {
      CARD_NO: String,
      utm_source: {
        type: [String, Number],
        required: false
      }
    },
    data() {
      return {
        record: {
          SL_TOTAL: 0,
          Y_POINT: 0,
        },
        IconArrowDown: IconArrowDownUrl
      };
    },
    mounted() {
      const vm = this;
      vm.$store.commit('toggleLoading', true);
      vm.$store.dispatch('member_card/getShoppingRecordHandler').then((res) => {
        vm.$store.commit('toggleLoading', false);
        vm.record = res.data;
        vm.changeLogoImage();
      });
    },
    methods: {
      toggleShowDetail(index) {
        const vm = this;
        if (vm.record.item[index].showDetail) {
          vm.$set(vm.record.item[index], 'showDetail', false);
        } else {
          vm.$set(vm.record.item[index], 'showDetail', true);
        }
      },
      numberFormat(number) {
        const str = number.toString().split('.');
        if (str[0] === '0') return 0;
        str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return str[0];
      },
      changeLogoImage() {
        const vm = this;
        try {
          vm.logoImg = require(`@/assets/images/card/memberCardHeader${vm.CARD_NO}.png`);
        } catch (e) {
          vm.logoImg = defaultLogoUrl;
        }
      },
    },
    computed: {
    }
  };
</script>

<style lang='scss' scoped>
  .text-red {
    color: #A52020;
  }

  .text {
    font-size: 14px;
  }
  .text-brown {
    color: #8B6F4B;
  }

  .whiteArea {
    background-color: #FFFFFF;
  }

  #signUpIndex {
    background-color: #F9F9F9;
  }

  .grayArea {
    background-color: #EFEFEF;
  }

  .text-gray {
    color: #999999;
  }

  .border-rounded {
    border-radius: 15px;
  }

  .box-shadow {
    box-shadow: rgba(0, 0, 0, 0.15) 3px 3px 15px;
  }

  .border-left-grown {
    border-left: 5px solid #867050;
  }

  .border-top-right-rounded {
    border-top-right-radius: 15px;
  }
  .border-bottom-right-rounded {
    border-bottom-right-radius: 15px;
  }

  .white-space-nowrap {
    white-space: nowrap;
  }

  .arrow-down-icon {
    position: absolute;
    right: 16px;
    bottom: 0;
  }
  .arrow-top-icon {
    position: absolute;
    right: 16px;
    bottom: 0;
    transform: rotate(180deg);
  }

  .content-padding-top {
    padding-top: 72px;
  }
</style>
